import React, { useState } from 'react';
import DialogComponent from '../components/DialogComponent/DialogComponent';
import InputComponent from '../components/InputComponent/InputComponent';
import { useNavigate } from 'react-router-dom';
import NotificationComponent from '../components/NotificationComponent/NotificationComponent';
import localDataStorage from '../store/localDataStorage';
import { userLogin, GetScreenMasterList } from '../services/apiController';
import { useDispatch, useSelector } from 'react-redux';
import { setIsAuthenticated, setScreenRights } from '../store/reduxMasterSlice';

const Login = (props) => {
    const { open, setOpen } = props;
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const eventMasterId = useSelector(state => state.reduxMaster.eventMasterId);

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({ username: '', password: '' });
    const [errors, setErrors] = useState({}); // To store validation errors

    // State to manage snackbar visibility and messages
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: '' }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!formData.username.trim()) newErrors.username = 'Username is required';
        if (!formData.password.trim()) newErrors.password = 'Password is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Clear any previous errors
        setErrors({});
        setLoading(true);

        const params = {
            username: formData.username,
            password: formData.password,
            ticket_master_id: eventMasterId
        }

        userLogin(params).then((response) => {
            if (response.status) {
                localDataStorage.setLocalStorage('username', formData.username);
                localDataStorage.setLocalStorage('password', formData.password);

                GetScreenMasterList({ userMasterId: response.userMasterId }).then((screenResponse) => {
                    dispatch(setScreenRights(screenResponse?.screens || []));
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    dispatch(setIsAuthenticated(true));

                    handleClose();
                    navigate("/qr-scanner", { replace: true });
                    setLoading(false);
                });
                return;
            } else {
                setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'error' });
            }
            setLoading(false);
        }).catch((error) => {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Something went wrong please try again", snackbarSeverity: 'error' });
            handleClose();
            setLoading(false);
        });
    }

    const handleClose = () => {
        setFormData({ username: '', password: '' });
        setErrors({});
        setOpen(false);
    };

    return (
        <React.Fragment>
            <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

            <DialogComponent
                isOpen={open}
                Title="Login"
                ActionText={"Login"}
                IsLoading={loading}
                onSave={handleSubmit}
                onClose={handleClose}
            >
                <form onSubmit={handleSubmit}>
                    <InputComponent name="username" placeholder="Username" value={formData.username} onChange={handleChange} error={errors.username} maxLength={25} /><br />
                    <InputComponent name="password" placeholder="Password" value={formData.password} onChange={handleChange} error={errors.password} maxLength={25} type="password" /><br />
                    <button type="submit" style={{ display: "none" }} />
                </form>

            </DialogComponent>
        </React.Fragment>
    );
};

export default Login;
